import { render, staticRenderFns } from "./HomeWork.vue?vue&type=template&id=a5e66ab8&scoped=true&"
import script from "./HomeWork.vue?vue&type=script&lang=js&"
export * from "./HomeWork.vue?vue&type=script&lang=js&"
import style0 from "./HomeWork.vue?vue&type=style&index=0&id=a5e66ab8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e66ab8",
  null
  
)

export default component.exports